<template>
  <div class="w-full max-h-screen bg-background flex flex-col relative">
    <PageHeader title="Internal"/>
    <main
        class="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
    >
      <!-- Staff Management -->
      <is-authorized
          :roles="['user']"
          :permissions="[
          'manage:staff',
          'create:staff',
          'read:staff',
          'update:staff',
          'delete:staff',
        ]"
      >
        <router-link
            to="/internal/staff"
            class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
        >
          <svg
              class="h-10 w-10 mr-5 stroke-current"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              viewBox="0 0 24 24"
          >
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
            <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" />
          </svg>

          <h2 class="text-lg uppercase">Staff Management</h2>
        </router-link>
      </is-authorized>


      <!-- Holiday Planner -->
      <is-authorized
          :roles="['user']"
          :permissions="['manage:leaveOwn', 'manage:leaveAll']"
      >
        <router-link
            to="/internal/holiday"
            class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
        >
          <svg
              class="stroke-current h-10 w-10 mr-5"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              viewBox="0 0 24 24"
          >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
            />
          </svg>

          <h2 class="text-lg uppercase">Holiday Planner</h2>
        </router-link>
      </is-authorized>

      <!-- Health and Safety -->
      <is-authorized :roles="['user']" :permissions="['manage:internal']">
        <router-link
            to="/internal/healthnsafety"
            class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
        >
          <svg
              class="stroke-current h-10 w-10 mr-5"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              viewBox="0 0 24 24"
          >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            />
          </svg>

          <h2 class="text-lg uppercase">Health and Safety</h2>
        </router-link>
      </is-authorized>

      <!-- Internal Certification -->
      <is-authorized :roles="['user']" :permissions="['manage:internal_docs']">
        <router-link
            to="/internal/documents"
            class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
        >
          <svg
              class="stroke-current h-10 w-10 mr-5"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              viewBox="0 0 24 24"
          >
            <path d="M12 14l9-5-9-5-9 5 9 5z"/>
            <path
                d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
            />
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
            />
          </svg>

          <h2 class="text-lg uppercase">Internal Docs</h2>
        </router-link>
      </is-authorized>



      <router-link
          to="/internal/service"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
        >
          <path stroke="none" d="M0 0h24v24H0z"/>
          <path
              d="M5 7a4 4 0 1 0 8 0 4 4 0 1 0-8 0M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2M16 3.13a4 4 0 0 1 0 7.75M21 21v-2a4 4 0 0 0-3-3.85"/>


        </svg>
        <h2 class="text-lg uppercase">Engineers</h2>
      </router-link>



      <router-link
          to="/internal/purchase"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            fill="none"

        >
          <path stroke="none" d="M0 0h24v24H0z"/>
          <path d="M4 19a2 2 0 1 0 4 0 2 2 0 1 0-4 0M15 19a2 2 0 1 0 4 0 2 2 0 1 0-4 0"/>
          <path d="M17 17H6V3H4"/>
          <path d="m6 5 14 1-1 7H6"/>
        </svg>
        <h2 class="text-lg uppercase">Purchasing</h2>
      </router-link>


      <router-link
          to="/internal/sales"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            fill="none"

        >
          <path stroke="none" d="M0 0h24v24H0z"/><path d="M3 13a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM9 9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM15 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM4 20h14"/>
        </svg>
        <h2 class="text-lg uppercase">Sales Orders & Despatch</h2>
      </router-link>

    </main>
  </div>
</template>

<script>
const PageHeader = () => import("@/components/PageHeader.vue");
const IsAuthorized = () => import("@/components/Auth/IsAuthorized.vue");

export default {
  name: "HR",
  components: {
    PageHeader,
    IsAuthorized,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
